import { FORM_ERROR } from "../../../app/constants/messages";

export function renderFormErrorMessages() {
    return FORM_ERROR('role')
}

export function renderTitle() {
    return null
}
